module.exports = __webpack_public_path__ + "e572d2e4b47f526831d57dd11e5220c6.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-32@2x.png
// module id = 512
// module chunks = 0